import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import _ from 'lodash';
import { useContext, useEffect, useRef, useState } from 'react';
import { Label, List, Segment } from 'semantic-ui-react';
import { AppUserContext } from '../../cnr/contexts/AppUserContext';
import { HelpContext } from '../../cnr/contexts/HelpContext';
import { _appSettingsCollectionName } from '../../cnr/reducers/BaseSettingsReducer';
import { helpTypes } from '../../cnr/reducers/HelpReducer';
import { uniqueKey } from '../../common/keys';
import { sortObjectRoot } from '../../common/sorting';
import { copyCodeToClipboard } from '../../common_web/copy';
import UiSaveButtons from '../../components/buttons/UiSaveButtons';
import { createRefPath } from '../../firestoreData/appData/appRefPaths';
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper';
import HelpEdit from './HelpEdit';
import { formatDescription, getEnumLabels, getHelpGroup, getHelps, groupIgnore, groupItemIgnore } from './helpSettings';
import { ParentContext } from 'global/cnr/contexts/ParentContext';

const _settingsTypes = {
  global: 'global',
  page: 'page',
  pageItem: 'pageItem',
  prop: 'prop',
  propSection: 'propSection',
}

const _settingsLinkTypes = {
  global: 'vw',
  page: 'vw',
  pageItem: 'vi',
  prop: 'pr',
  propSection: 'ps',
}

export const HelpDoc = () => {

  const parentContext = useContext(ParentContext);
  const { fns } = parentContext ?? {}
  const { database_fns } = fns

  // appUserContext
  const appUserContext = useContext(AppUserContext);
  const { appUser_state } = appUserContext ?? {}
  const appUserAccess = useAppUserAccess()
  const { isSuperAdmin } = appUserAccess ?? {}

  // frameworkContext
  const helpContext = useContext(HelpContext);
  const { help_state } = helpContext ?? {}
  const { helpDocs, allHelpItems } = help_state ?? {}
  const { helpDocuments, helpDocs: _helpDocs } = helpDocs ?? {}

  const [initJson] = useState(helpDocuments ? JSON.stringify(helpDocuments) : {});
  const [helpEditItem, setHelpEditItem] = useState();
  const [helpGroupSelectedItem, setHelpGroupSelectedItem] = useState();
  const [helpSelectedItem, setHelpSelectedItem] = useState({});
  const [groupSettings, setGroupSettings] = useState();
  // const [pasteValue, setPasteValue] = useState()

  const textAreaRef = useRef()

  const handleDbSettings = (result) => {
    const { global, page, pageItem, prop, propSecton } = result ?? {}
    const gs = {
      global: global ?? {},
      page: page ?? {},
      pageItem: pageItem ?? {},
      prop: prop ?? {},
      propSecton: propSecton ?? {},
    }
    if (allHelpItems) {
      Object.keys(allHelpItems).forEach(k => {
        const hi = allHelpItems[k]
        const { keys, description } = hi ?? {}
        if (keys) {
          keys.forEach(key => {
            const hds = helpDocuments[key]
            if (hds) {
              Object.keys(hds).forEach(hdsKey => {
                const hd = hds[hdsKey]
                if (hd && hd.items && hd.items[k]) {
                  if (!hd.items[k].description || hd.items[k].description === '') {
                    hd.items[k].description = description
                  }
                }
              })
            }

          })
        }
      })
    }
    setGroupSettings(gs)
  }

  useEffect(() => {
    const _refPath = createRefPath([_appSettingsCollectionName, 'app', 'settings'])
    database_fns.get_data({ refPath: _refPath, callback: handleDbSettings, opts: { ignoreId: true } })
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  const handleCopy = () => copyCodeToClipboard(textAreaRef)
  const handleOnChange = () => { }
  const handleCloseHelpEdit = () => setHelpEditItem()
  const handleHelpEdit = (hsProps, helpType) => {
    if (isSuperAdmin && !helpEditItem) {
      setHelpEditItem({
        hsProps,
        helpType,
      })
    }
  }

  const handleShowGroupHelpItem = (groupSettingType) => setHelpGroupSelectedItem(groupSettingType === helpGroupSelectedItem ? null : groupSettingType)
  const handleShowHelpItem = (groupSettingType, helpDocSubField) => setHelpSelectedItem(helpSelectedItem && helpSelectedItem.helpSelectedItem === helpGroupSelectedItem ? null : { groupSettingType, helpDocSubField })

  const helpEdit = () => {
    const helpProps = { ...helpEditItem, handleCloseHelpEdit }
    return <HelpEdit helpProps={helpProps} />
  }

  const groupItemHelp = (hsProps, groupSettingItem, helpGroup) => {

    const items = []
    const { groupItems } = groupSettingItem
    const srt = _.sortBy(groupItems, 'prop')

    Object.keys(srt).forEach(key => {

      if (!groupItemIgnore(key)) {
        const gsi = srt[key]
        const { prop } = gsi
        const hssProps = { ...hsProps, helpProp: prop }
        const { description } = getHelps(helpGroup, hssProps, allHelpItems)
        const enums = getEnumLabels(prop)

        items.push(
          <List.Item key={uniqueKey('gih', key)} onClick={_e => handleHelpEdit(hssProps, helpTypes.documents)}>
            <List.Content>
              <List.Header >{_.startCase(gsi.prop)}</List.Header>
              <List.Description >{formatDescription(description, 'mark-help-doc')}</List.Description>
              {enums && <List.Description className={'help-list'}>{enums}</List.Description>}
              {isSuperAdmin && helpEditItem && (helpEditItem.hsProps && (helpEditItem.hsProps.helpProp === prop) && helpEditItem.helpType === helpTypes.documents) && helpEdit()}
            </List.Content>
          </List.Item>
        )
      }
    })
    return <List relaxed>
      {items}
    </List>
  }

  const groupHelp = (groupSettingType, groupSetting) => {
    const items = []
    const srt = sortObjectRoot(groupSetting)
    Object.keys(srt).forEach(helpDocSubField => {
      if (!groupIgnore(helpDocSubField)) {
        const groupSettingItem = srt[helpDocSubField]
        if (groupSettingItem && groupSettingItem.groupItems && Object.keys(groupSettingItem).length > 0) {

          const hsProps = { helpDocField: _settingsLinkTypes[groupSettingType], helpDocSubField }
          const helpGroup = getHelpGroup(helpDocuments, hsProps)
          const { description } = getHelps(helpGroup, hsProps, allHelpItems)

          const gsiCount = Object.keys(groupSettingItem.groupItems).length
          const helpCount = helpGroup && helpGroup.items ? Object.keys(helpGroup.items).length : 0

          const showItem = helpSelectedItem && helpSelectedItem.groupSettingType === groupSettingType && helpSelectedItem.helpDocSubField === helpDocSubField

          items.push(
            <Segment.Group className={'help-seg doc'} key={uniqueKey('gih', groupSettingType, helpDocSubField)}>
              <Segment basic className={'help-group-item-header'} onClick={_e => handleShowHelpItem(groupSettingType, helpDocSubField)}>{_.startCase(helpDocSubField)}<div><Label color={'blue'}>{gsiCount}</Label><Label color={'green'}>{helpCount}</Label></div></Segment>
              {showItem && <Segment basic className={'help-group-item-description'} onClick={_e => handleHelpEdit(hsProps, helpTypes.documents)}>{formatDescription(description, 'mark-help-doc')}</Segment>}
              {showItem && isSuperAdmin && helpEditItem && (helpEditItem.hsProps && (helpEditItem.hsProps.helpDocSubField === helpDocSubField) && !helpEditItem.hsProps.helpProp && helpEditItem.helpType === helpTypes.documents) && helpEdit()}
              {showItem && <Segment basic>{groupItemHelp(hsProps, groupSettingItem, helpGroup)}</Segment>}
            </Segment.Group >
          )
        }
      }
    })
    return items
  }

  const helpGroups = () => {
    const segs = []
    if (groupSettings) {
      Object.keys(groupSettings).forEach(groupSettingType => {
        const groupSetting = groupSettings[groupSettingType]
        let hgc;
        switch (groupSettingType) {
          case _settingsTypes.global:
            hgc = 'Global'
            break;
          case _settingsTypes.page:
            hgc = 'Pages'
            break;
          case _settingsTypes.pageItem:
            hgc = 'Page Items'
            break;
          case _settingsTypes.prop:
            hgc = 'Props'
            break;
          case _settingsTypes.propSection:
            hgc = 'Prop Sections'
            break;
          default:
            return false;
        }
        const showItem = helpGroupSelectedItem === groupSettingType
        segs.push(<Segment.Group key={uniqueKey('gih', groupSettingType)}>
          <Segment className={'help-group-header'} onClick={_e => handleShowGroupHelpItem(groupSettingType)}>{hgc}</Segment>
          {showItem && <Segment>{groupHelp(groupSettingType, groupSetting)}</Segment>}
        </Segment.Group>)
      })
    }
    return segs
  }

  const helpContent = () => <div id={'helper'} className={'help-container hc'} >
    {helpGroups()}
    <textarea
      key={uniqueKey('gih', 'hc')}
      ref={textAreaRef}
      value={JSON.stringify(initJson, null, 3)}
      style={{ position: 'absolute', left: '-999em' }}
      onChange={handleOnChange}
    />
  </div>

  return <Wrapper
    content={helpContent()}
    footer={<UiSaveButtons
      save={{ oc: handleCopy, caption: 'Copy' }}
    />}
    wrapperType={wrapperTypes.paddedFooter}
    updating={!groupSettings}
  />

}